import React, { FC } from 'react';
import { CircularProgress } from '@mui/material';
import './Loader.scss';

const Loader: FC = () => (
	<div className="Loader">
		<div className="Spinner">
			<CircularProgress />
		</div>
	</div>
);

export default Loader;
